// 按页面划分
export default {
    // 公共页面
    common: {
        title:"데이터 몰",
        pull_refresh: '새로 고침을 당기십시오',
        release_refresh: '새로 고침하려면 릴리스',
        refresh_loading: '로딩…',
        footer_text: '서비스는 Ucloudlink（NASDAQ: UCL）에서 제공됩니다'
      },
      home: {
        input_placeholder: '검색 국가/지역',
        my_flow: '내 데이터',
        charge_code: '바우처 코드',
        coupons:'쿠폰',
        local_package: '로컬 데이터',
        more: '더',
        popular_destination: '국가/지역',
        buy_now: '지금 구매하십시오',
        package_useing: '활성화',
        unused: '비활성화',
        download_app: '앱을 다운로드하십시오',
        enter_the_mall_list: '쇼핑몰 목록에 들어갑니다',
        no_data: '데이터가 없습니다',
        no_data_available: '사용 가능한 데이터가 없습니다',
        copy_success: '복사 성공',
        copy_fail: '복사 실패',
        meritsTitle: '장점은 무엇입니까？',
        merits1: 'SIM 없이 & 월요금 없음',
        merits2: '상위 2-3 운영사 통합, 네트워크 자동 전환',
        go_buy: '구입하다',
        instant_savings: '절약',
        expires_in: '만료까지',
        download_app_tips: "앱 다운로드하고 더 많은 혜택과 경험을 누리세요"
      },
      packages: {
        sub_title: {
          us: '괌 제외, 사이판',
          it: '바티칸 시티, 산 마리노 포함',
          va: '이탈리아, 산 마리노 포함',
          sm: '이탈리아, 바티칸 시티 포함',
          ma: '서부 사하라 포함',
          eh: '모로코를 포함하여',
          ch: '리히텐슈타인 포함',
          li: '스위스 포함',
          fr: '모나코를 포함하여',
          mc: '프랑스 포함',
          fi: 'Aland Islands 포함',
          ax: '핀란드를 포함하여',
          gu: '북부 마리아나 제도를 포함하여',
          mp: '괌 포함'
        },
        unlimited_packages: '무제한 데이터 패키지',
        normal_packages: '일반 데이터 패키지',
        multi_region_packages: '다중 지역',
        regional_data: '지역 데이터',
        high_speed_text: '고속 데이터',
        infiniteFlow:'무제한 데이터',
        unLimitData: '무제한',
        high_speed_text_year: '고속/MP',
        package_list: '패키지 목록',
        special_offer: '세일',
        first_month: '1개월차',
        periodUnit: {
          day: '날)',
          month: '월',
          hour: '시간 (들)',
          year: '년도',
        },
        periodUnits: {
          day: '날)',
          month: '달',
          hour: '시간 (들)',
          year: '연령',
        },
        periodUnitSimp: {
          day: '디',
          month: '모',
          hour: '시간',
          year: '예멘 아랍 공화국'
        },
        periodUnitMonthly:'월간',
        periodUnitsSimp: {
          day: '디',
          month: '모',
          hour: '시간',
          year: '예멘 아랍 공화국'
        },
        unlimited_good_name: {
          day: '당일 패스',
          month: '월간 패스',
          year: '매년 패스'
        },
        continuousMonth : "지속적인 달",
        continuousDay : "연속적인 날",
        continuousYear:"연속적인 시절",
        
        
        day_invalid: '현재 날에 만료됩니다',
        month_invalid: '현재 달에 만료됩니다',
        immediate_valid: '즉시 효과적입니다',
        tomorrow_day_valid: '다음날부터 효과적입니다',
        tomorrow_month_valid: '다음 달부터 시행됩니다',
    
    
        // detail page
        detail: {
          cell_flow: '데이터',
          cell_period: '효력',
          buy_quantity: '양',
          use_area: '적용 범위',
          use_intro: '이용 약관',
          buy_btn: '주문하다',
          pay: '지불하다',
          buy_tips: '%@packageName 패키지를 사용 중입니다. 이 패키지를 구매하시겠습니까？',
          haveOrderTips: "결제 대기 주문 생성됨. 확인 클릭 후 내 데이터 페이지로 이동하여 확인！"
        },
    
        // confirm page
        confirm: {
          title: '주문 확인',
          real_pay_amount: '지불 금액',
          online_payment: '온라인 결제',
          create_order_error: '설정이 실패했습니다'
        }
      },
      pay: {
        // result page
        result: {
          loading_order_status: '주문 상태 얻기…',
          buy_success: '주문 완료',
          buy_pending: '보류중인 확인',
          buy_pending_tip: '결제 프로세스… 10 분 이내에 지불금이 양도되지 않은 경우 지원을 받으려면 저희에게 연락하십시오.',
          get_payment_info_fail: '결제 정보 수집에 실패했습니다',
          cell_package: '패키지',
          cell_buy_amount: '소계',
          cell_real_amount: '지불 금액',
          go_to_order_btn: '내 패키지로 이동하십시오',
          back_home: '집으로 돌아갑니다',
          back_mall: '쇼핑몰로 돌아갑니다',
          ordersn_empty: '주문 SN은 비어있을 수 없습니다',
          order_search_error: '예상치 못한 오류',
          goodsName:'제품 이름'
        },
    
        //fail page
        fail: {
          payment_fail: '결제가 실패했습니다',
          back_home: '집으로 돌아갑니다'
        }
      },
      CountryGroup: {
        title: "국가/지역",
        placeholder: "검색 국가 또는 지역",
        clear: "분명한",
        history: "검색 기록"
      },
      PromotionCode: {
        verification: {
          title: '바우처 코드',
          minititle:'바우처 코드',
          input: '상단 코드를 입력하십시오',
          explain: '팁: 바우처 카드의 QR 코드를 스캔하려면 오른쪽 상단의 스캔 버튼을 터치하세요. 스캔이 안 될 경우 바우처 코드(대소문자 구분)를 직접 입력하세요.',
          submit: '제출하다',
          exchange: '상환하다',
          cancel: '취소',
          Inquiry: "당신은 확실히 교환할까요?",
          ErrorCode: '충전 코드 오류',
        },
        recharge_success: {
          package: '패키지',
          content: '성공적으로 상환',
          back: '쇼핑몰로 돌아갑니다',
          view_packets: '내 패키지로 이동하십시오'
        }
      },
      order: {
        state: {
          inUse: '활성화',
          isFirst: '우선 순위',
          toFirst: '우선 순위를 설정하십시오',
          inactive: '비활성화'
        },
        periodUnits: {
          minute: '분)',
          hour: '시간 (들)',
          day: '날)',
          month: '달 (들)',
        },
        useIntro: {
          tip1: '무제한 데이터 패키지는 볼륨 데이터 패키지보다 우선 순위가 높습니다.;',
          tip2: '사용 우선 순위는 동일한 유형의 패키지에 대한 구매 날짜를 기준으로합니다. 즉, 구매 날짜 초기가 가장 오래된 패키지는 먼저 사용되는 반면 단일 지역 패키지의 우선 순위는 지역 패키지보다 높습니다.;',
          tip3: '동일한 유형의 패킷 사용 우선 순위를 수동으로 조정할 수도 있습니다.'
        },
        myFlow: '내 데이터',
        remainingFlow: '데이터가 남았습니다',
        remainingTime: '유효한 왼쪽',
        remainingHighFlow: '고속 데이터가 남았습니다',
        validPeriod: '효력',
        noneFlow: '데이터 패키지가 없습니다',
        noneFlowTip: '데이터 패키지를 구매하고 고품질 네트워크를 즐기십시오.',
        buyPackFlow: '패키지 구매',
        checkInvalidFlow: '만료 된 데이터 패키지를 확인하십시오',
        orderList: {
          "title": "내 주문",
          "amount_paid": "총",
          "device": "소유한 기기",
          "order_details": "주문 세부정보",
          "total_amont": "소계",
          "orderSN": "주문번호",
          "createTime": "생성 시간",
          "cancelTime": "휴관시간",
          "payTime": "주문시간",
          "unsubTime": "취소된 시간",
          "payMethod": "결제수단",
          "thirdSN": "거래번호",
          "delete": "삭제",
          "cancel": "주문 취소",
          "unsub": "환불하다",
          "goto_cancel": "주문을 취소하시겠습니까?",
          "goto_unsubscribe": "주문을 취소하시겠습니까?",
          "delete_Tips": "주문이 삭제된 후에는 재개할 수 없으므로 애프터 서비스 문제를 처리할 수 없습니다.삭제하시겠습니까?",
          "status_success": "완전한",
          "status_pending": "미지급",
          "status_cancel": "닫은",
          "status_unsub": "취소",
          "payMethod_stripe": "신용카드"
        },
      },
      registerlogin: { 
        create_account_tip:'계정을 만들고 독점 경험을 시작하십시오',
        select_country_tip:'장치 사용 국가/지역',
        email_name: '우편',
        phone_name: '핸드폰',
        email_address: '이메일 주소',
        password: '비밀번호',
        country: '국가',
        select_country: '국가를 선택하십시오',
        cancel: '취소',
        confirm: '확신하는',
        please_enter: '6-20 자 (문자, 숫자 또는 기호의 조합)를 입력하십시오.',
        select_country_tips: '국가 선택은 로컬 패키지를보기위한 것입니다.등록 후에는 변경할 수 없습니다.확인하십시오!',
        global_roaming: '국제 도메인 코드',
        phone_number: '전화 번호',
        agree: '동의하다',
        user_agreement: '사용자 계약',
        and: '그리고',
        privacy_policy: '개인 정보 보호 정책',
        register_login: '가입하거나 로그인하십시오',
        login_error: "로그인 수가 너무 빈번합니다. 나중에 다시 시도하십시오!",
        register_error: "등록 수가 너무 빈번합니다. 나중에 다시 시도하십시오!",
        forgot_pwd: '비밀번호를 잊어 버리십시오',
        app_tips: '더 많은 기능에 액세스하려면이 계정을 다운로드 한 후이 계정으로 앱에 로그인하십시오.',
        download_app:'앱을 다운로드하십시오',
        rememberPwd: '비밀번호 기억하기',
        third_login: "로 계속하기",
        agreement_tips: "사용자 계약 및 개인정보 보호정책 확인란을 선택해 주세요.",
        selectCountry_tips: "등록하시는 국가에 따라 이용 가능한 결제 수단 및 통화가 달라지므로, 필요에 따라 선택해 주시기 바랍니다.",
        login_error_cancel: "사용자가 로그인을 취소했습니다",
        login_error_auth: "브라우저 설정에서 팝업을 허용해 주세요",
        device_tips: "기기 활성화 대기 중. 24시간 이내 처리됩니다."
      },
      forgotPwd: {
        forgot_pwd: '비밀번호를 잊어 버리십시오',
        email_address: '이메일 주소',
        next: '다음',
        email_has_been_sent: '우리는 이메일을 %@email로 보냈습니다.링크를 클릭하고 단계를 따라 비밀번호를 검색하십시오.',
        have_retrieved_it: '나는 그것을 발견했다',
        unable_to_receive_email: '이메일을받을 수 없습니까?스팸 및 삭제 된 메일 디렉토리 아래에서 %@email의 이메일이 있는지 확인하십시오.',
        or: '또는',
        resend: '재판소',
        global_roaming: '국제 도메인 코드',
        phone_number: '전화 번호',
        verification_code_has_been_sent: '검증 코드를 다음으로 보냈습니다.',
        verification_code: '확인 코드',
        no_verification_code_received: '확인 코드를받지 못했습니까?',
        please_enter: '6-20 자 (문자, 숫자 또는 기호의 조합)를 입력하십시오.',
        reset_password: '비밀번호 재설정',
        reset_successful: '성공적으로 재설정되었습니다'
      },
      coupons: {
        coupons_name: '쿠폰',
        no_coupons: '아직 쿠폰이 없습니다',
        no_data: '아직 데이터가 없습니다',
        applicable_to_the_following:'쿠폰은 다음 데이터 패키지에 적합합니다'
      },
      digital: {
          title: "장치 SN",
          purchased: "내 구매",
          viewAll: "더 보기",
          skinStore: "제품 저장소",
          completed: "구매",
          goBuy: "구입하다",
          order: {
              title: "구매 주문"
          },
          detail: {
              describe: "설명"
          }
      },
      viewPL: {
        other: '기타'
      },
      invalidFlow: {
        stateName: '상태',
        state: {
          NOT_ACTIVATED: "비활성화",
          IN_USING: "사용 가능",
          USE_END: "탈진한",
          EXPIRE: "만료되었습니다",
          TRANSFER: "옮기다",
          UNSUBSCRIBE: "취소",
          VALID: "유효한",
          INVALID: "유효하지 않은",
          EXCHANGE_POINTS: "포인트를 상환합니다"
        },
        noneFlow: '만료 된 데이터 패키지가 없습니다',
        pageName: '만료 된 데이터 패키지'
      },
      flowDetail: {
        title: '데이터 세부 사항',
        flow: '데이터',
        validTime: '유효한 시작',
        invalidTime: '최대 유효합니다',
        coverage: '적용 범위',
        useIntro: '이용 약관',
        purchaseTime: '구매',
        subtotal: '소계',
        status: '상태',
        cancel: '취소',
        buyAgain: '다시 구입하십시오',
        validity: '효력',
        tip: '알아채다',
        cancelTip: '이 패키지를 환불 하시겠습니까?',
        dataLeft: '데이터가 남았습니다'
      },
      netError: {
        try_again: '다시 시도하십시오',
        net_error: '네트워크가 없습니다',
        try_again_desc: '네트워크 설정을 확인하고 다시 시도하십시오'
      },
      loadFail: {
        try_again: '다시 시도하십시오',
        load_fail: '로드가 실패했습니다',
        load_fail_desc: '데이터로드가 실패했습니다. 다시 시도하십시오',
        IMEI_Not_Exist: 'IMEI는 존재하지 않습니다. 오른쪽 입구에서 입력하십시오',
        Project_Not_Exist:'오류가 발생합니다.고객 서비스에 문의하십시오. (01)',
        commonError:'오류가 발생합니다.고객 서비스에 문의하십시오.',
      },
      settlement_Easy_and_convenient:"쉽고 편리합니다",
      settlement_Great_deal:"큰 거래",
      settlement_Safe_and_secure:"안전하고 안전합니다",
      settlement_Autopay_service_regulation:"자동 판매 서비스 규정",
      settlement_Read:"읽다",
      settlement_No_coupon:"사용 가능한 쿠폰이 없습니다",
      settlement_Subtotal:"소계",
      settlement_Coupon:"쿠폰",
      settlement_TOTAL:"총",
      settlement_promotion_tip:"프로모션 제안은 모든 쿠폰과 함께 사용할 수 없습니다.",
      settlement_coupon_tip:"쿠폰은 다른 프로모션 제안과 함께 사용할 수 없습니다.",
      member_myFlow_noList:"데이터가 없습니다",
      detail_se_content:"안전하고 쉽고 편리한 방법.언제든지 구독을 취소 할 수 있습니다",
      Enter_Promo_code:"프로모션 코드",
      Enter_Promo_Coupon:"쿠폰",
      settlement_Not_used_coupon:"쿠폰이 사용되지 않습니다",
      settlement_Available_coupon:"사용 가능",
      settlement_Unavailable_coupon:"없는",
      please_Enter_Promo_code:"프로모션 코드를 입력하십시오",
      please_Select_Coupon_use: "사용하려는 쿠폰을 선택하십시오.",
      Buy_Now:"지금 구매하십시오",
      Dont_Use_Any:"사용하지 마십시오",
      settlement_confirm:"확인하다",
      settlement_tips:"확인하다",
      flowDetail_unsubscribe: "구독 취소",
      flowDetail_unsubscribed: "구독되지 않은",
      flowDetail_isCancelPackage: "이 패키지를 구독 취소 하시겠습니까?",
      flowDetail_confirmAgreementUnsubscribe : "구독 취소 후에는 큰 거래를 할 수 없습니다.구독 취소 하시겠습니까?",
      flowDetail_cancel: "취소",
      flowDetail_cancelSuccess: "성공적으로 구독 취소",
      packages_detail_promotion:"홍보",
      orderTips:{
        "iDay" : "낮",
        "iDays" : "날",
        "iMonth" : "월",
        "iMonths" : "달",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol 첫 구매시, 나중에 %@money/%@periodSymbol 을 지불하십시오, 언제든지 구독을 취소 할 수 있습니다",
        'Monthly_discount':"%@saveMoney 각 %@period를 저장하십시오!언제든지 구독을 취소 할 수 있습니다",
        'Ordinary_monthly_package':"안전하고 쉽고 편리한 방법.언제든지 구독을 취소 할 수 있습니다",
        "AlreadyPurchased":'현재 하나의 데이터 패키지 만 구독 할 수있어서 죄송합니다.“%@”를 구독하고 나중에 만료 된 후 원하는 패키지를 구독하십시오.',
        "Contract_recommendation_First":'<label>AutoPay Service를 사용하면 첫 구매시 지불 만 지불하십시오</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">언제든지 구독을 취소 할 수 있습니다'
        +'<a class="btn">구독하다 ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>AutoPay 서비스를 사용하면 지불하십시오</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">언제든지 구독을 취소 할 수 있습니다'
        +'<a class="btn">구독하다 ></a></p>',
        "Contract_recommendation_General":"<label>AutoPay 서비스와 함께</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">안전하고 쉽고 편리한 방법.언제든지 구독을 취소 할 수 있습니다'
        +'<a href="javascript:;" class="btn">구독하다 ></a></p>',
        'BanlanceDoubleCheck':'잔액으로 지불하고 싶습니까?',
    },
    feedback: {
      title: "피드백",
      placeholder: "방문하고자하는 나라 나 다른 질문에 들어가면 가능한 한 빨리 귀하의 요구를 충족시킬 것입니다!",
      submit: "제출하다",
      submit_success: "성공적으로 제출되었습니다",
      other_opinions: "기타 의견",
    },
    view_country_input: '귀하의 계정을 입력해주세요',
    select_package: {
      title: '데이터 선택',
      allPackage: '모든 데이터',
      type: '타입',
      flow: '데이터',
      month_package: '월 플랜',
      flow_package: '데이터 패키지',
      time: '사용 시간',
      period: '주기',
      auto_debit: '자동결제 안내',
      auto_subscribe: '자동갱신',
      detail: '데이터 상세',
      carrier: '지원되는 캐리어',
      country: '대상국가 목록',
      notice: '구매 가이드라인'
    },
}